import { render, staticRenderFns } from "./EpisodesListItem.vue?vue&type=template&id=fc85f41e&scoped=true"
import script from "./EpisodesListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EpisodesListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EpisodesListItem.vue?vue&type=style&index=0&id=fc85f41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85f41e",
  null
  
)

export default component.exports